import React from 'react'
import {Helmet} from 'react-helmet'
import {KS_HOMEPAGE_SCHEMA_MARKUP_ASSET_ID} from '../../../constants'
import useContentAsset from '../../../hooks/use-content-asset'

const SchemaMarkup = () => {
    const {data: contentAssetBody} = useContentAsset(KS_HOMEPAGE_SCHEMA_MARKUP_ASSET_ID)
    let organizationMarkupData = {}
    let siteMarkupData = {}
    try {
        if (!contentAssetBody) {
            return
        }
        const organizationContentBody = JSON.parse(contentAssetBody.contentAssetHTML)
        organizationMarkupData = {
            '@context': 'https://schema.org/',
            '@type': 'Corporation',
            name: organizationContentBody.organizationName.toString(),
            url: organizationContentBody.organizationUrl.toString(),
            logo: organizationContentBody.organizationLogo.toString(),
            description: organizationContentBody.organizationDescription.toString(),
            contactPoint: [],
            sameAs: []
        }
        organizationMarkupData.contactPoint.push({
            '@type': 'ContactPoint',
            telephone: organizationContentBody.organizationTelephone.toString(),
            contactType: 'Customer Service',
            contactOption: 'TollFree',
            areaServed: ['US', 'GB', 'CA'],
            availableLanguage: 'en'
        })
        organizationMarkupData.sameAs.push(
            organizationContentBody.organizationFacebookLink.toString(),
            organizationContentBody.organizationTwitterLink.toString(),
            organizationContentBody.organizationInstagramLink.toString(),
            organizationContentBody.organizationYoutubeLink.toString(),
            organizationContentBody.organizationLinkedinLink.toString(),
            organizationContentBody.organizationPinterestLink.toString(),
            organizationContentBody.organizationWikipediaLink.toString()
        )

        var targetURL = 'https://www.kendrascott.com/search?q={search_term_string}'
        siteMarkupData = {
            '@context': 'https://schema.org/',
            '@type': 'WebSite',
            name: organizationContentBody.organizationName.toString(),
            url: 'https://www.kendrascott.com/',
            potentialAction: {
                '@type': 'SearchAction',
                target: decodeURI(targetURL),
                'query-input': 'required name=search_term_string'
            }
        }
    } catch (e) {
        console.error(e)
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(organizationMarkupData)}</script>
            <script type="application/ld+json">{JSON.stringify(siteMarkupData)}</script>
        </Helmet>
    )
}

export default SchemaMarkup
